import { useQuery } from "@tanstack/react-query";
import branchesService from "services/admin/branchesService";

export const useBranches = () =>
  useQuery({
    queryKey: ["branches-list"],
    queryFn: async () => {
      const res = await branchesService.getAll({ limit: 200 });
      return res?.data
    },
    staleTime: 10 * 60 * 1000,
  });
